import { v4 as uuidv4 } from 'uuid'
import ApiClient from 'api-client/ApiClient'
import store from 'app/store'
import ActionsSet from 'core/actions/ActionsSet'
import CreateAction from 'core/actions/CreateAction'
import DeleteAction from 'core/actions/DeleteAction'
import ListAction from 'core/actions/ListAction'
import DataKeys, { entityNamesByKey } from 'k8s/DataKeys'

const { dispatch } = store
const { appcatalog } = ApiClient.getInstance()

export const repositoryActions = ActionsSet.make<DataKeys.Repository>({
  uniqueIdentifier: 'uid',
  entityName: entityNamesByKey.Repository,
  cacheKey: DataKeys.Repository,
})

export const listRepositories = repositoryActions.add(
  new ListAction<DataKeys.Repository>(async () => {
    return appcatalog.getRepositories()
  }),
  //    .addDependency(DataKeys.OpenstackSubnets)
)

export const createRepository = repositoryActions.add(
  new CreateAction<DataKeys.Repository, { body }>(async ({ body }) => {
    const created = await appcatalog.createRepository(body)
    const repoId = created?.uid
    const newRepo = await appcatalog.getRepository(repoId)
    return newRepo
  }),
)

export const deleteRepository = repositoryActions.add(
  new DeleteAction<DataKeys.Repository, { uid: string }>(async ({ uid }) => {
    await appcatalog.deleteRepository(uid)
  }),
)

export const validateSshKeyActions = ActionsSet.make<DataKeys.Repository>({
  uniqueIdentifier: 'id',
  entityName: entityNamesByKey.Repository,
  cacheKey: DataKeys.Repository,
})

export const validateSshKey = validateSshKeyActions.add(
  new CreateAction<DataKeys.Repository, { body }>(async ({ body }) => {
    await appcatalog.validateSshKey(body)
    return null
  }),
)

export const branchDetailsActions = ActionsSet.make<DataKeys.RepositoryBranches>({
  uniqueIdentifier: 'uid',
  entityName: entityNamesByKey.RepositoryBranches,
  cacheKey: DataKeys.RepositoryBranches,
})

export const listBranches = branchDetailsActions.add(
  new ListAction<DataKeys.RepositoryBranches, { uid: string }>(async ({ uid }) => {
    const branches = await appcatalog.getRepositoryBranch(uid)
    return branches?.map((branch) => ({ name: branch, uid: uuidv4() }))
  }),
)

export const templateActions = ActionsSet.make<DataKeys.Templates>({
  uniqueIdentifier: 'uid',
  entityName: entityNamesByKey.Templates,
  cacheKey: DataKeys.Templates,
})

export const listTemplates = templateActions.add(
  new ListAction<DataKeys.Templates>(async () => {
    return appcatalog.getTemplates()
  }),
)

export const createTemplate = templateActions.add(
  new CreateAction<DataKeys.Templates, { body }>(async ({ body }) => {
    const created = await appcatalog.createTemplate(body)
    const templateId = created?.uid
    const newTemplate = await appcatalog.getTemplate(templateId)
    return newTemplate
  }),
)

export const deleteTemplate = templateActions.add(
  new DeleteAction<DataKeys.Templates, { uid: string }>(async ({ uid }) => {
    await appcatalog.deleteTemplate(uid)
  }),
)

export const fetchTerraformModuleActions = ActionsSet.make<DataKeys.TerraformModule>({
  uniqueIdentifier: 'id',
  entityName: entityNamesByKey.TerraformModule,
  cacheKey: DataKeys.TerraformModule,
})

export const listTerraformModules = fetchTerraformModuleActions.add(
  new ListAction<DataKeys.TerraformModule>(async () => {
    return appcatalog.getTemplates()
  }),
)

export const fetchTerraformModule = fetchTerraformModuleActions.add(
  new CreateAction<DataKeys.TerraformModule, { body }>(async ({ body }) => {
    return await appcatalog.fetchTerraformModule(body)
  }),
)

export const ApplicationActions = ActionsSet.make<DataKeys.Applications>({
  uniqueIdentifier: 'uid',
  entityName: entityNamesByKey.Applications,
  cacheKey: DataKeys.Applications,
})

export const listApplications = ApplicationActions.add(
  new ListAction<DataKeys.Applications>(async () => {
    return appcatalog.getApplications()
  }),
)

export const createApplication = ApplicationActions.add(
  new CreateAction<DataKeys.Applications, { body }>(async ({ body }) => {
    const created = await appcatalog.createApplication(body)
    const appId = created?.uid
    const newApp = await appcatalog.getApplication(appId)
    return newApp
  }),
)

export const deleteApplication = ApplicationActions.add(
  new DeleteAction<DataKeys.Applications, { uid: string }>(async ({ uid }) => {
    await appcatalog.deleteApplication(uid)
  }),
)

export const ApplicationDetailsActions = ActionsSet.make<DataKeys.ApplicationDetails>({
  uniqueIdentifier: 'uid',
  entityName: entityNamesByKey.ApplicationDetails,
  cacheKey: DataKeys.ApplicationDetails,
})

export const listApplicationDetails = ApplicationDetailsActions.add(
  new ListAction<DataKeys.ApplicationDetails, { uid: string }>(async ({ uid }) => {
    const appErrorDetails = await appcatalog.getApplicationDetails(uid)
    return [{ error: appErrorDetails, uid: uuidv4() }]
  }),
)
